import { IconSocialMax24, IconSocialTelegram24, IconSocialVK24 } from '@cian/ui-kit-design-tokens/icons';
import { MAX_LINK, TG_LINK, VK_LINK } from 'shared/constants/links';

export const SOCIALS = [
  {
    id: 1,
    Icon: IconSocialVK24,
    url: VK_LINK,
  },
  {
    id: 2,
    Icon: IconSocialMax24,
    url: MAX_LINK,
  },
  {
    id: 3,
    Icon: IconSocialTelegram24,
    url: TG_LINK,
  },
];
